/**
 * @file
 * Hero video text reveal.
 */
(function (Drupal, once) {
  "use strict";

  Drupal.behaviors.umsiHeroReveal = {
    attach: function (context) {
      var wrappers = once("umsiHeroReveal", ".hero-reveal", context);

      wrappers.forEach(function (wrapper) {
        var parent = wrapper.parentNode;
        var control = wrapper.querySelector(".hero-video__control--reveal");
        var video = wrapper.querySelector(".hero-video");
        var panel = wrapper.querySelector(".hero-panel");
        var headline = wrapper.querySelector(".hero-headline__text");
        var header = document.querySelector(".header");

        function publishHeaderHeight() {
          if (!header) {
            return;
          }
          var h = Math.round(header.getBoundingClientRect().height) + "px";
          wrapper.style.setProperty("--hero-header-h", h);
          document.documentElement.style.setProperty("--hero-header-h", h);
        }

        function publishHeadlineExtra() {
          if (!headline) {
            return;
          }
          var cs = window.getComputedStyle(headline);
          var line = parseFloat(cs.lineHeight);
          if (!line) {
            line = parseFloat(cs.fontSize) * 1.2;
          }
          var pad =
            parseFloat(cs.paddingTop || 0) + parseFloat(cs.paddingBottom || 0);
          var extra = Math.max(
            0,
            headline.getBoundingClientRect().height - line - pad,
          );
          wrapper.style.setProperty(
            "--hero-headline-extra",
            Math.round(extra) + "px",
          );
        }

        function publish(value) {
          wrapper.style.setProperty("--hero-progress", value);
          if (parent && parent.style) {
            parent.style.setProperty("--hero-progress", value);
          }
        }

        var ticking = false;

        function update() {
          ticking = false;
          var rect = wrapper.getBoundingClientRect();

          var distance = window.innerHeight * 0.6;
          var progress = Math.min(Math.max(-rect.top / distance, 0), 1);
          publish(progress.toFixed(4));

          if (control && video) {
            var v = video.getBoundingClientRect();
            var videoGone =
              v.bottom <= 0 ||
              (panel &&
                panel.getBoundingClientRect().top <= v.top + v.height * 0.25);
            wrapper.classList.toggle("is-control-hidden", videoGone);
          }
        }

        function onScroll() {
          if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(update);
          }
        }

        function onResize() {
          publishHeaderHeight();
          publishHeadlineExtra();
          onScroll();
        }

        publishHeaderHeight();
        publishHeadlineExtra();
        update();
        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", onResize, { passive: true });
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(function () {
            publishHeaderHeight();
            publishHeadlineExtra();
          });
        }
      });
    },
  };
})(Drupal, once);
